import React from 'react';

import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { Component } from 'models';

import { ComponentOverviewHit } from 'components/component-overview/ComponentOverviewHit';
import { DatasheetMode, useDatasheetMode } from 'components/datasheet/DatasheetMode';
import { CarouselSection } from 'components/section/CarouselSection';

import { useComponentContext } from '../../hooks/use-component-context';
import { useDatasheetProductSeriesComponents } from '../../hooks/use-datasheet-product-series-components';
import { ComponentDatasheetSection } from './ComponentDatasheetSection';

const ProductVariants = () => {
    const mode = useDatasheetMode();

    const { component } = useComponentContext();
    const { components: variants, isLoading } = useDatasheetProductSeriesComponents();

    const otherVariants = CollectionHelpers.exclude(variants, component.id, 'id');

    if (mode !== DatasheetMode.VIEW || !otherVariants.length || isLoading) {
        return null;
    }

    return (
        <ComponentDatasheetSection title="Products in this Series" alwaysShow>
            <CarouselSection nbCols={4}>
                {otherVariants.map((variant: Component) => (
                    <ComponentOverviewHit key={variant.id} component={variant} showEmptyImage />
                ))}
            </CarouselSection>
        </ComponentDatasheetSection>
    );
};

export { ProductVariants };
